import * as React from "react";
import { routes, endpoints } from "configs";
import classNames from "classnames";
import { deleteAllCachedAssignment } from "configs/store/offline-mode/actions";
import { generatePath, request } from "utils";
import { clearAppLocalStorage } from "pages/app/duck/operations";
import { dialog, MenuItem, Typography } from "components";
import * as Types from "./types";
import { CambiumCode } from "../components";
import styles from "../UserNav.module.css";

const userLinks: Types.UserLinks = ({
  t,
  setAuth,
  profileType,
  profileId,
  logoutUrl,
  dispatch,
  disabledItem,
  setDisabledItem,
  closeDropdown,
}) => {
  const sharedLinks = [
    {
      path: routes.home,
      title: t("header.openLoginPage"),
      text: t("header.logout"),
      onClick: () => {
        clearAppLocalStorage();

        if (logoutUrl && navigator.onLine) {
          window.location.href = logoutUrl;
        } else {
          setAuth({ isLoggedIn: false, data: {} as any });
          dispatch(deleteAllCachedAssignment());
        }
      },
    },
  ];

  // just for demo purposes
  // revert after demo
  const cambium = window.location.hostname?.startsWith("devapp")
    ? [
        <MenuItem
          disabled={disabledItem}
          className={classNames(styles.item, {
            [styles.itemDisabled]: disabledItem,
          })}
          onClick={() => {
            setDisabledItem(true);
            request
              .post(endpoints.generateCambium)
              .then(
                ({
                  data: {
                    data: { cambiumCode },
                  },
                }) => {
                  closeDropdown();
                  dialog.open({
                    title: t("cambium.title") as string,
                    content: () => <CambiumCode code={cambiumCode} />,
                  });
                },
              )
              .finally(() => {
                setDisabledItem(false);
              });
          }}
        >
          <div className={styles.link}>
            <Typography variant="p2" component="span">
              {t("header.generateCambiumCode") as string}
            </Typography>
          </div>
        </MenuItem>,
      ]
    : [];

  return (
    (profileType === "Student" && [
      {
        path: routes.settings,
        title: t("header.openSettings"),
        text: t("header.settings"),
      },
      {
        path: generatePath(routes.studentAccount, { id: profileId }),
        title: t("header.openAccount"),
        text: t("header.account"),
      },
    ]) ||
    (profileType === "Teacher" && [
      {
        path: routes.settings,
        title: t("header.openSettings"),
        text: t("header.settings"),
      },
      {
        path: generatePath(routes.preferences, { id: profileId }),
        title: t("header.openPreferences"),
        text: t("header.preferences"),
      },
      ...cambium,
    ]) ||
    []
  ).concat(sharedLinks);
};

export default userLinks;
